import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { CreateSiteComponent } from './create-site.component';

@Injectable()
export class CreateSiteService {
  constructor(private dialog: MatDialog) {}

  public open(data: any): Observable<any> {
    let dialogRef: MatDialogRef<CreateSiteComponent>;
    dialogRef = this.dialog.open(CreateSiteComponent, {
      data: data
    });

    return dialogRef.afterClosed();
  }
}
